// The naming convention for segment events:
// prefix each event with "orcas-" and then append the action
// example: orcas-accept-assignment-button-clicked

export default {
  MAO_ACCEPT_NOW_CLICK: 'orcas-accept-now-button-clicked',
  MAO_ACCEPT_NOW_CONFIRMATION_CLOSED: 'orcas-accept-now-confirmation-closed',
  MAO_ACCEPT_NOW_REQUEST_SENT: 'orcas-accept-now-request-sent',
  MAO_ACCEPT_NOW_REQUEST_SUCCESS: 'orcas-accept-now-request-success',
  MAO_ACCEPT_NOW_REQUEST_FAILURE: 'orcas-accept-now-request-failure',
  MAO_BUTTON_CLICK: 'orcas-make-an-offer-button-clicked',
  MAO_DIALOG_CLOSED: 'orcas-make-an-offer-dialog-closed',
  MAO_NOT_RELEVANT_OFFER_CLICK: 'orcas-non-relevant-offer-clicked',
  MAO_ORDER_DETAILS_DIALOG_CLOSED: 'orcas-order-detail-dialog-closed',
  MAO_ORDER_DETAILS_DIALOG_OPENED: 'orcas-order-detail-dialog-opened',
  MAO_RELEVANT_OFFER_CLICK: 'orcas-relevant-offer-clicked',
  MAO_REQUEST_SENT: 'orcas-make-an-offer-request-sent',
  MAO_SUGGESTED_PRICE_MISMATCHED: 'orcas-suggested-cost-price-is-mismatched',
  MAO_NLS_OPENED: 'orcas-suggested-order-details-opened',
  MAO_NLS_CLOSED: 'orcas-suggested-order-details-closed',
  MAO_NLS_ACCEPTED: 'orcas-suggested-load-accept-now-clicked',
  MAO_NLS_OFFER: 'orcas-suggested-load-offer-clicked',
  ODV_ACCEPT_NOW_TRIGGERED: 'orcas-accept-now-order-triggered',
  ODV_REQUEST_OFFER_TRIGGERED: 'orcas-request-offer-triggered',
  ODV_MULTI_STOPS_LIMIT_REACHED: 'orcas-multistop-limit-reached',
  VAS_BANNER_CLICK: 'orcas-banner-click',
  MARKETPLACE_REFRESH_BUTTON_CLICKED: 'orcas-marketplace-refresh-button-clicked',
  MARKETPLACE_SEARCHING_FOR_OFFERS_QUERY:
    'orcas-marketplace-searching-for-offers-from-query-string',
  MARKETPLACE_SEARCHING_FOR_OFFERS_FORM:
    'orcas-marketplace-searching-for-offers-from-form',
  ASSIGNMENTS_ACCEPT_CLICK: 'orcas-accept-assignment-button-clicked',
  ASSIGNMENTS_REJECT_CLICK: 'orcas-reject-assignment-button-clicked',
  TRANSPORT_REGISTRATION_SUBMIT: 'orcas-transport-registration-submit-button-clicked',
  SWITCH_TO_NEW_ORCAS: 'orcas/click/switch-to-new-orcas'
}
